// views/proveedores/productos/AjustarPreciosProveedorModal.js

import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { ajustarPreciosProveedor } from '../../../actions/proveedores';
import { setAlert } from '../../../actions/alert';

const AjustarPreciosProveedorModal = ({ show, onClose, idProveedor, nombreProveedor }) => {
    const dispatch = useDispatch();

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [tipo, setTipo] = useState('incremento');
    const [porcentajePublico, setPorcentajePublico] = useState('');
    const [porcentajeMinimo, setPorcentajeMinimo] = useState('');
    const [porcentajeLiquidacion, setPorcentajeLiquidacion] = useState('');

    const handleCerrar = () => {
        if (statusProcesar) return;

        setTipo('incremento');
        setPorcentajePublico('');
        setPorcentajeMinimo('');
        setPorcentajeLiquidacion('');
        onClose();
    };

    const handleGuardar = async () => {
        if (!idProveedor) return;

        const pPublico = parseFloat(porcentajePublico) || 0;
        const pMinimo = parseFloat(porcentajeMinimo) || 0;
        const pLiquidacion = parseFloat(porcentajeLiquidacion) || 0;

        if (pPublico === 0 && pMinimo === 0 && pLiquidacion === 0) {
            dispatch(setAlert('Captura al menos un porcentaje distinto de cero', 'danger'));
            return;
        }

        setStatusProcesar(true);

        const ok = await dispatch(ajustarPreciosProveedor(idProveedor, {
            tipo,
            porcentaje_publico: pPublico,
            porcentaje_minimo: pMinimo,
            porcentaje_liquidacion: pLiquidacion
        }));

        setStatusProcesar(false);

        if (ok) {
            handleCerrar();
        }
    };

    return (
        <Modal show={show} size="md" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Ajustar precios {nombreProveedor ? `de ${nombreProveedor}` : ''}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-muted mb-3" style={{ fontSize: 13 }}>
                    El porcentaje se aplica a los 3 precios de <strong>todos</strong> los productos de este proveedor.
                    Deja en blanco el precio que no quieras modificar.
                </div>

                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="btn-group w-100" role="group">
                            <button
                                type="button"
                                className={`btn ${tipo === 'incremento' ? 'btn-success' : 'btn-outline-success'}`}
                                onClick={() => setTipo('incremento')}
                                disabled={statusProcesar}
                            >
                                <i className="fas fa-arrow-up fa-sm"></i> Incremento
                            </button>
                            <button
                                type="button"
                                className={`btn ${tipo === 'decremento' ? 'btn-danger' : 'btn-outline-danger'}`}
                                onClick={() => setTipo('decremento')}
                                disabled={statusProcesar}
                            >
                                <i className="fas fa-arrow-down fa-sm"></i> Decremento
                            </button>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="porcentaje_publico"
                                    placeholder="% Público"
                                    value={porcentajePublico}
                                    onChange={(e) => setPorcentajePublico(e.target.value)}
                                    min="0"
                                    step="0.01"
                                    disabled={statusProcesar}
                                />
                                <label htmlFor="porcentaje_publico">% Precio público</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="porcentaje_minimo"
                                    placeholder="% Mínimo"
                                    value={porcentajeMinimo}
                                    onChange={(e) => setPorcentajeMinimo(e.target.value)}
                                    min="0"
                                    step="0.01"
                                    disabled={statusProcesar}
                                />
                                <label htmlFor="porcentaje_minimo">% Precio mínimo</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="porcentaje_liquidacion"
                                    placeholder="% Liquidación"
                                    value={porcentajeLiquidacion}
                                    onChange={(e) => setPorcentajeLiquidacion(e.target.value)}
                                    min="0"
                                    step="0.01"
                                    disabled={statusProcesar}
                                />
                                <label htmlFor="porcentaje_liquidacion">% Liquidación</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCerrar}
                    disabled={statusProcesar}
                >
                    <i className="fas fa-times fa-sm"></i> Cancelar
                </button>

                {statusProcesar ? (
                    <button type="button" className="btn btn-success" disabled>
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>{' '}
                        Guardando
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleGuardar}
                    >
                        <i className="fas fa-check fa-sm"></i> Aplicar
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default AjustarPreciosProveedorModal;
